import {
    ButtonPrimary,
    ButtonFixedFooterLayout,
    Text3,
    BoxedRow,
    RadioButton,
    RadioGroup,
    NavigationBar,
    skinVars,
    IconShieldCrossRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { formatMobileNumber, hideEmailCharacters } from '../../../../utils/dataTransformation/unitsConversion';
import { Text6 } from '@telefonica/mistica';
import { isBrowser } from 'react-device-detect';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const ContactInfoVerified: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const pattern = /"|]/gi;
    const contactsRegex = params.get('contacts')!.replaceAll(pattern, '').replaceAll('[', '').replaceAll(' ', '');
    const contacts: string[] = contactsRegex.split(',');
    const [valueVerification, setValueVerification] = useState<any>('');
    const typeOfContact = valueVerification.includes('@') ? 'email' : 'mobile';
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const sendToNative = (url: string, type: string, title?: string) => {
        const storage = {};
        const queryParams = {
            type: typeOfContact,
            contact: valueVerification,
        };
        if (navigateParams(type, url, queryParams, storage, title)) {
            navigate(url + '?type=' + typeOfContact + '&contact=' + valueVerification, valueVerification);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (windowWidth >= 1024) {
        return (
            <div className='desktop-contact-info-verified'>
                <div className='desktop-contact-info-verified__header-navigationBar'>
                    <NavigationBar isInverse={true} title={''} />
                </div>
                <div className='desktop-contact-info-verified__left'>
                    <div className='desktop-contact-info-verified__left__icon'>
                        <IconShieldCrossRegular size={64} color={skinVars.colors.brand}></IconShieldCrossRegular>
                    </div>
                    <div className='desktop-contact-info-verified__left__title'>
                        <Text6 color={skinVars.colors.textPrimary}>{t('otpFlowTitle')}</Text6>
                    </div>
                    <div className='desktop-contact-info-verified__left__subtitle'>
                        <Text3 regular color={skinVars.colors.textSecondary}>
                            {t('otpFlowSubtitle')}
                        </Text3>
                    </div>
                </div>
                <div className='desktop-contact-info-verified__right'>
                    <div className='contact-info-verified'>
                        <div className='contact-info-verified__title'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {t('contacVerifiedTitle')}
                            </Text3>
                        </div>
                        <div className='contact-info-verified__radioGroup'>
                            <RadioGroup name={'verification'} value={valueVerification} onChange={setValueVerification}>
                                {contacts?.map((contact: string, index: any) => {
                                    const _contact = contact.includes('@') ? 'email' : 'mobile';
                                    return (
                                        <div className='contact-info-verified__radioGroup__boxedRow' key={index}>
                                            <BoxedRow
                                                title={
                                                    _contact === 'email'
                                                        ? t('personalDataEmail')
                                                        : t('personalDataMobile')
                                                }
                                                description={
                                                    _contact === 'mobile'
                                                        ? formatMobileNumber(contact)
                                                        : hideEmailCharacters(contact)
                                                }
                                                right={
                                                    <div className='contact-info-verified__radioGroup__boxedRow__radioButton'>
                                                        <RadioButton value={contact}></RadioButton>
                                                    </div>
                                                }
                                            ></BoxedRow>
                                        </div>
                                    );
                                })}
                            </RadioGroup>
                        </div>
                        <div className='contact-info-verified__buttonPrimary'>
                            <ButtonPrimary
                                disabled={valueVerification === ''}
                                onPress={() => {
                                    sendToNative(
                                        '/escalation/otp/send',
                                        'modeFlow-backgroundBlue',
                                        valueVerification.includes('@')
                                            ? 'Verificar dirección de email'
                                            : 'Verificar móvil de contacto',
                                    );
                                }}
                            >
                                {t('next')}
                            </ButtonPrimary>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='contact-info-verified'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary
                            disabled={valueVerification === ''}
                            onPress={() => {
                                sendToNative(
                                    '/escalation/otp/send',
                                    'modeFlow-backgroundBlue',
                                    valueVerification.includes('@')
                                        ? 'Verificar dirección de email'
                                        : 'Verificar móvil de contacto',
                                );
                            }}
                        >
                            {t('next')}
                        </ButtonPrimary>
                    }
                >
                    {isBrowser && (
                        <div className='c-customer-agreement-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate('/profile');
                                }}
                                title={'Seleccionar medio de contacto'}
                            />
                        </div>
                    )}

                    <div className='contact-info-verified__title'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('contacVerifiedTitle')}
                        </Text3>
                    </div>
                    <div className='contact-info-verified__radioGroup'>
                        <RadioGroup name={'verification'} value={valueVerification} onChange={setValueVerification}>
                            {contacts?.map((contact: string, index: number) => {
                                const _contact = contact.includes('@') ? 'email' : 'mobile';
                                return (
                                    <div className='contact-info-verified__radioGroup__boxedRow' key={index}>
                                        <BoxedRow
                                            title={
                                                _contact === 'email' ? t('personalDataEmail') : t('personalDataMobile')
                                            }
                                            description={
                                                _contact === 'mobile'
                                                    ? formatMobileNumber(contact)
                                                    : hideEmailCharacters(contact)
                                            }
                                            right={
                                                <div className='contact-info-verified__radioGroup__boxedRow__radioButton'>
                                                    <RadioButton value={contact}></RadioButton>
                                                </div>
                                            }
                                        ></BoxedRow>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        );
    }
};

export default ContactInfoVerified;
